import { ReactNode } from 'react';
import * as React from 'react';
import styled from 'styled-components';

import Label from 'packages/kakapo-ui-kit/components/forms/controls/Label';
import { style, FieldContainer } from 'packages/kakapo-ui-kit/components/forms/controls/Field';

interface IProps {
	icon?: ReactNode;
	label?: string;
	title: string;
	onClick: (event: React.MouseEvent<HTMLAnchorElement>) => void;
	fullWidth?: boolean;
	inline?: boolean;
	color?: string;
}

interface IElementProps {
	fullWidth?: boolean;
	inline?: boolean;
	color?: string;
}

const Element = styled.a<IElementProps>`
	${style}
`;

export default function FieldDummyAction({
	icon,
	label,
	title,
	onClick,
	fullWidth,
	inline,
	color,
}: IProps) {
	return (
		<FieldContainer>
			{label && <Label title={label} htmlFor={label} />}
			<Element id={label} fullWidth={fullWidth} onClick={onClick} inline={inline} color={color}>
				{icon}
				{title}
			</Element>
		</FieldContainer>
	);
}
